var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 146,
    viewBox: "0 0 115 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3364 145.332V71.48H3.34439V145.332H11.3364ZM7.34039 51.648C4.08439 51.648 0.976389 54.756 0.976389 58.012C0.976389 61.416 4.08439 64.376 7.34039 64.376C10.5964 64.376 13.7044 61.416 13.7044 58.012C13.7044 54.756 10.5964 51.648 7.34039 51.648ZM97.4955 3.104C90.8355 0.439996 82.6955 1.032 76.6275 4.584C71.1515 7.84 66.5635 13.908 64.1955 21.308C62.1235 27.524 61.0875 35.072 61.0875 42.916V69.112H34.2995V76.956H61.0875V145.48H68.9315V76.956H101.048V69.112H68.9315V42.916C68.9315 35.812 69.9675 29.152 71.5955 23.676C73.6675 18.052 76.7755 13.908 80.6235 11.392C84.7675 8.87599 89.7995 8.43199 94.3875 10.356C102.232 13.464 104.748 22.048 106.672 32.112L114.516 30.632C112.444 19.68 108.596 7.69199 97.4955 3.104Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIf);
export default __webpack_public_path__ + "static/media/IF.e5881d4fe1e771e6a305ae9cf88129a7.svg";
export { ForwardRef as ReactComponent };